<mat-nav-list>

    <a mat-list-item (click)="openLink($event)" *ngFor="let bottom of data" (click)="navegar(bottom)">
        <mat-icon>{{bottom.icono}}</mat-icon>
        <span mat-line><b>{{bottom.title}}</b></span>
        <span mat-line>{{bottom.subTitle}}</span>
        <mat-divider></mat-divider>
    </a>
</mat-nav-list>